export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ../node_modules/d3-axis/src/array.js
// module id = 20
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 29